<template>
  <RouterView />
</template>

<script setup lang="ts">
import { useConvexClient } from 'convex-vue';
import { RouterView, useRouter } from 'vue-router';
import { ensureConvexAuthBootstrap, type InviteAuthBootstrapFailure } from './convex/auth';

const convexClient = useConvexClient();
const router = useRouter();

function handleInviteTokenFailure(failure: InviteAuthBootstrapFailure): void {
  const reason = failure.reason === 'expired' ? 'expired' : undefined;
  const currentReason = Array.isArray(router.currentRoute.value.query.reason)
    ? router.currentRoute.value.query.reason[0]
    : router.currentRoute.value.query.reason;

  if (router.currentRoute.value.name === 'invalid-session' && currentReason === reason) {
    return;
  }

  void router.replace({
    name: 'invalid-session',
    ...(reason ? { query: { reason } } : {}),
  });
}

ensureConvexAuthBootstrap(convexClient, undefined, {
  onInviteTokenFailure: handleInviteTokenFailure,
});
</script>
